/* eslint no-prototype-builtins: "off" */

'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const Container = require('./../../../../core/container');
const Translator = require('./../../../../core/translator');
const Mediator = require('./../../../../core/mediator');

const Zone = require('./../../../../services/structure/zone');
const Formbuilder = require('./../../../../services/form');
const PopinManager = require('./../../../../services/popin');
const Loader = require('./../../../../services/loader');
const FlashMessage = require('./../../../../services/flashMessage');
const FixHeight = require('./../../../../services/fixHeight');

const Help = require('./../../../../services/help');

const Repo = require('./../../repository/LangRepository');

const indexTpl = require('./template/index.hbs');

let currentData;

const changeLangsStatus = function(langs) {
    let promises = [];

    for (let key in langs) {
        if (langs.hasOwnProperty(key)) {
            promises.push(Repo[langs[key] ? 'enable': 'disable'](key));
        }
    }

    return jQuery.when.apply(undefined, promises).promise();
};

module.exports.onFinish = function() {
    let popin = PopinManager.createPopin({
        'title': Translator.translate('default_lang_finish_title'),
        'minHeight': 50,
        'buttons': [
            {
                class: 'popin popin-ok',
                text: Translator.translate('submit'),
                click: function() {
                    popin.hide();
                },
            },
        ],
    });

    popin.setContent(`<p>${Translator.translate('default_lang_finish_message')}</p>`);

    popin.on('close', function() {
        Mediator.publish('menu:more-parameters:lang_management:click', {'newPanel': true});
    });

    popin.display();
};

const getModifiedData = function(data) {
    let result = null;

    _.forEach(currentData, function(lang) {
        let currentLang = data[lang.id];

        if (lang.is_active !== currentLang) {
            result = result || {};
            result[lang.id] = currentLang;
        }
    });

    return result;
};

module.exports.onClick = function(config = {}) {
    let newPanel = config.newPanel;
    let $container = jQuery('<div></div>');

    let $layer = Zone[newPanel ? 'setSmallPanel' : 'addLayer'](Translator.translate('lang_management'), $container, {
        'extraTitle': Help.createLink('lang_management'),
    });

    Loader.start($layer);

    Repo.findAll().done(function(data) {
        currentData = data;

        let langsOption = {};
        let defaultLang = null;

        langsOption.lang = Translator.translate('language_default_value');

        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                let lang = data[key];
                langsOption[lang.id] = lang.label;

                if (lang.is_default) {
                    defaultLang = lang.id;
                }
            }
        }

        let elementsConfig = {};

        if (!defaultLang) {
            elementsConfig.lang = {
                'type': 'select',
                'options': langsOption,
                'value': 'lang',
                'group': {
                    'id': 'default_lang',
                },
            };
        }

        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                let lang = data[key];

                elementsConfig[lang.id] = {
                    'type': 'switch',
                    'value': !defaultLang ? false : lang.is_active,
                    'label': lang.label + (lang.is_default ? ` (${Translator.translate('default_lang')})` : ''),
                    'disabled': !defaultLang ? true : lang.is_default,
                };
            }
        }

        let form = Formbuilder.getForm({
            'elements': elementsConfig,
            'form': {
                'submit_class': 'd-none',
            },
        });

        let $langManagement = jQuery(indexTpl({
            'description': Translator.translate(defaultLang ? 'select_active_lang_description' : 'select_default_lang_description'),
        }));

        $langManagement.append(form.render());

        $container.append($langManagement);

        Loader.stop($layer);

        form.on('submit', function(data) {
            Loader.start($layer);

            if (typeof config.onSubmit === 'function') {
                config.onSubmit(form);
            }

            if (defaultLang) {
                let modifiedData = getModifiedData(data);

                if (null !== modifiedData) {
                    changeLangsStatus(modifiedData).done(function() {
                        Loader.stop($layer);
                        Zone.hidePanels(Container.get('$smallPanel'));

                        FlashMessage.add(Translator.translate('multilang_parameters_saved'), 'success');

                        location.reload();
                    });
                } else {
                    Loader.stop($layer);
                    Zone.hidePanels(Container.get('$smallPanel'));
                }
            } else {
                Repo.setDefault(data.lang).done(function() {
                    localStorage.setItem('flash-callback', '[{"type":"lang-finish"}]');
                    location.reload();
                });
            }
        });

        Zone.setFooter($layer, Zone.createSubmitButtons({
            onSubmitClick: function() {
                if (defaultLang) {
                    form.submit();
                } else {
                    if ($container.find('select[name=lang]').val() === 'lang') {
                        let $errMessage = jQuery('<span class="error">' + Translator.translate('default_language_error') + '</span>');
                        $container.find('div.element_lang').append($errMessage);
                    } else {
                        let popin = PopinManager.createPopin({
                            'title': Translator.translate('default_lang_popin_title'),
                            'minHeight': 50,
                            'buttons': [
                                {
                                    class: 'popin popin-cancel',
                                    text: Translator.translate('discard'),
                                    click: function() {
                                        popin.hide();
                                    },
                                },
                                {
                                    class: 'popin popin-ok',
                                    text: Translator.translate('submit'),
                                    click: function() {
                                        form.submit();
                                    },
                                },
                            ],
                        });

                        Container.set('prevent-hide-overlay', true);

                        $container.find('span.error').remove();
                        let confirmationMessage = Translator.translate('default_lang_confirmation_message');
                        confirmationMessage = confirmationMessage.replace('_LANG_', langsOption[$container.find('select[name=lang]').val()]);

                        popin.setContent('<p>'+confirmationMessage+'</p>');

                        popin.on('close', function() {
                            setTimeout(function() {
                                Container.set('prevent-hide-overlay', false);
                            }, 100);
                        });

                        popin.display();
                    }
                }
            },
        }));

        FixHeight.fix($container, jQuery(window).height() - 165);
    });
};
